import React, { useState, useEffect } from 'react'
import uniqid from 'uniqid'

import InputChipsWithSearchUI from './InputChipsWithSearchUI'

const InputChipsWithSearch = ({
  values = { chips: [], input: '' },
  onChange,
  placeholder,
  regex,
  buttons,
  hiddenButtons,
  data,
  lockedChips,
  customClassName
}) => {
  const [isOpenResultsContainer, setIsOpenResultsContainer] = useState(false)
  const [parsedData, setParsedData] = useState([])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (data) {
        const itemsIndex = []

        for (const item of data) {
          for (const value of Object.keys(item)) {
            for (const chip of values.chips || []) {
              if (chip.value === item[value] || chip.name === item[value]) {
                const itemIndex = data.findIndex(item => item[value] === chip.value || item[value] === chip.name)
                itemsIndex.push(itemIndex)
              }
            }
          }
        }

        if (itemsIndex.length) {
          const newData = [...data]
          for (let i = itemsIndex.length - 1; i >= 0; i--) {
            newData.splice(itemsIndex[i], 1)
          }
          setParsedData(newData)
        } else {
          setParsedData(data)
        }
      } else {
        setParsedData([])
      }
    }

    return () => isSubscribed = false
  }, [data])

  const handleEvents = ({ key, data }) => {
    if (key === ' ') {
      const chipsValue = values.chips || []
      const chips = data ? [
        ...chipsValue,
        {
          id: uniqid(),
          ...data,
          isValid: true
        }
      ] : [
        ...chipsValue,
        {
          id: uniqid(),
          value: values.input || '',
          isValid: regex ? regex.test(values.input || '') : true
        }
      ]

      onChange({ chips, input: '' })
      setParsedData([])
      setIsOpenResultsContainer(false)
    }

    if (key === 'Backspace' && !values.input) {
      const chipsValue = values.chips || []
      if (chipsValue.length && lockedChips && chipsValue.length <= lockedChips.value) {
        return lockedChips.handle(chipsValue[chipsValue.length - 1])
      }

      const newChips = [...chipsValue]
      newChips.splice(-1, 1)
      onChange({ ...values, chips: newChips })
    }
  }

  const handleDeleteChip = ({ chipId }) => {
    const chipsValue = values.chips || []
    if (lockedChips && chipsValue.length <= lockedChips.value) {
      return lockedChips.handle(chipsValue.filter(chip => chip.id === chipId))
    }

    const newChips = chipsValue.filter(chip => chip.id !== chipId)
    onChange({ ...values, chips: newChips })
  }

  return (
    <InputChipsWithSearchUI
      values={values}
      onChange={onChange}
      placeholder={placeholder}
      buttons={buttons}
      hiddenButtons={hiddenButtons}
      isOpenResultsContainer={isOpenResultsContainer}
      setIsOpenResultsContainer={setIsOpenResultsContainer}
      data={parsedData}
      handleEvents={handleEvents}
      handleDeleteChip={handleDeleteChip}
      lockedChips={lockedChips}
      customClassName={customClassName}
    />
  )
}

InputChipsWithSearch.defaultProps = {
  values: {
    chips: [],
    input: ''
  },
  buttons: {}
}

export default InputChipsWithSearch
